import React from 'react';

import { ReprovarItemClausula } from '@app/api/minuta/Clausula';
import { Button, FormatText, FormInput, FormSubmitButton, MasterDetailForm, Row, Widget } from '@digital/ui';
import { Modal } from 'antd';
import * as Yup from 'yup';

interface PropsModal {
  onUpdate: any;
  exibirModal: boolean;
  setExibirModal: React.Dispatch<React.SetStateAction<boolean>>;
  idItem: string;
}

const ModalJustificativaReprovacao = (props: PropsModal) => {
  const { onUpdate, exibirModal, setExibirModal, idItem } = props;

  const handleSubmit = (values: any) => {
    ReprovarItemClausula({ id: idItem, justificativaReprovacao: values.justificativaReprovacao }).then(data => onUpdate());
    setExibirModal(false);
  };

  return (
    <>
      <Modal
        title="TEMPLATE"
        width="1200px"
        visible={exibirModal}
        onCancel={() => {
          setExibirModal(false);
        }}
        footer={null}>
        <MasterDetailForm
          validationSchema={Yup.object().shape({
            justificativaReprovacao: Yup.string()
              .required('A justificativa da reprovação deve ser informado.')
              .max(300, 'A justificativa da reprovação deve ter no máximo 300 caracteres.'),
          })}
          key="formTemplate"
          onSubmit={handleSubmit}
          actions={[
            <Button
              key="close"
              type="link"
              onClick={() => {
                setExibirModal(false);
              }}>
              Fechar
            </Button>,
            <FormSubmitButton key="save" noIcon type="primary">
              <FormatText id="ui.commons.save" uppercase />
            </FormSubmitButton>,
          ]}>
          <Widget>
            <Row style={{ margin: '0px' }}>
              <FormInput label="Justificativa da reprovação" name="justificativaReprovacao" span={6} />
            </Row>
          </Widget>
        </MasterDetailForm>
      </Modal>
    </>
  );
};

export default ModalJustificativaReprovacao;
